exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons-preview[data-v-61554533] {\n  margin-left: -102px;\n  margin-top: 16px;\n  position: relative;\n  margin-bottom: 20px;\n  width: 436px;\n}\n.single-button--vertical.single-button[data-v-61554533] {\n  margin-left: 80px;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  width: fit-content;\n}\n", ""]);

// exports
